import type { IconData } from '@stacksjs/iconify-core'

export const bb4x3: IconData = {
  "body": "<path fill=\"#00267f\" d=\"M0 0h640v480H0z\"/><path fill=\"#ffc726\" d=\"M213.3 0h213.4v480H213.3z\"/><path id=\"SVGRWuOWdLt\" fill=\"#000001\" d=\"M319.8 135.5c-7 19-14 38.6-29.2 53.7c4.7-1.6 13-3 18.2-2.8v79.5l-22.4 3.3c-.8 0-1-1.3-1-3c-2.2-24.7-8-45.5-14.8-67c-.5-2.9-9-14-2.4-12c.8 0 9.5 3.6 8.2 1.9a85 85 0 0 0-46.4-24c-1.5-.3-2.4.5-1 2.2c22.4 34.6 41.3 75.5 41.1 124c8.8 0 30-5.2 38.7-5.2v56.1H320l2.5-156.7z\"/><use width=\"100%\" height=\"100%\" href=\"#SVGRWuOWdLt\" transform=\"matrix(-1 0 0 1 639.5 0)\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default bb4x3
